<script setup>
import { nextTick, reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import NextInput from 'dashboard/components-next/input/Input.vue';
import WithLabel from 'v3/components/Form/WithLabel.vue';

const props = defineProps({
  variables: { type: Array, default: () => [] },
  isLoading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'test']);
const { t } = useI18n();
const dialogRef = ref(null);
const values = reactive({});

const templateValues = () =>
  props.variables.reduce((result, variable) => {
    result[variable.namespace] ||= {};
    result[variable.namespace][variable.key] = values[variable.id] || '';
    return result;
  }, {});

nextTick(() => dialogRef.value?.open?.());
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="lg"
    :title="t('CORTEX.TOOLS.FORM.TEST_DIALOG_TITLE')"
    :description="t('CORTEX.TOOLS.FORM.TEST_DIALOG_DESCRIPTION')"
    :confirm-button-label="t('CORTEX.TOOLS.FORM.RUN_TEST')"
    confirm-button-icon="i-lucide-play"
    cancel-button-icon="i-lucide-x"
    :is-loading="isLoading"
    @confirm="emit('test', templateValues())"
    @close="emit('close')"
  >
    <div class="grid gap-4">
      <p v-if="!variables.length" class="text-sm text-n-slate-11">
        {{ t('CORTEX.TOOLS.FORM.TEST_NO_VARIABLES') }}
      </p>
      <WithLabel
        v-for="variable in variables"
        :key="variable.id"
        :name="`cortex-tool-test-${variable.id}`"
        :label="variable.label"
        :help-message="variable.expression"
      >
        <NextInput
          v-model="values[variable.id]"
          class="w-full"
          :placeholder="t('CORTEX.TOOLS.FORM.TEST_VARIABLE_PLACEHOLDER')"
          required
        />
      </WithLabel>
    </div>
  </Dialog>
</template>
